const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1025 1024",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4946,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_8",
    transform: "matrix(1,0,0,1,4946.2,1.13687e-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "rgb(132,83,48)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.913983,0.405752,-0.405752,0.913983,-4287.38,-2174.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5635.76,506.171C5649.76,506.171 5661.45,516.83 5662.74,530.768C5663.32,537.828 5663.63,545.082 5663.63,555.053C5663.63,726.538 5539.47,861.762 5458.2,861.762C5376.94,861.762 5252.78,726.538 5252.78,555.053C5252.78,545.082 5253.09,537.828 5253.69,530.771C5254.99,516.848 5266.67,506.2 5280.65,506.2C5352.35,506.171 5564.06,506.171 5635.76,506.171ZM5251.57,462.693C5240.03,462.693 5229.12,457.386 5221.99,448.299C5209.57,432.613 5202.68,415.464 5202.68,397.485C5202.68,324.195 5317.18,264.693 5458.2,264.693C5599.23,264.693 5713.73,324.195 5713.73,397.485C5713.73,415.464 5706.84,432.613 5694.36,448.254C5687.25,457.323 5676.36,462.62 5664.83,462.62C5595.49,462.693 5320.92,462.693 5251.57,462.693Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1257,0.499742,-0.499742,1.1257,-5404.29,-2751.85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5484.6,227.305C5485.47,201.444 5493.98,175.009 5511.11,156.088C5519.45,146.884 5518.74,132.643 5509.54,124.307C5500.33,115.971 5486.09,116.677 5477.76,125.881C5453.64,152.507 5440.85,189.397 5439.63,225.788C5439.21,238.199 5448.94,248.615 5461.36,249.034C5473.77,249.452 5484.18,239.716 5484.6,227.305Z",
    style: {
      fill: "white"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.cb16565accd8a879c267259e211b8fab.svg";
export { ForwardRef as ReactComponent };